import { setConfirmEndExam, setJobDetailModal, setSelectedJob } from '../../../../../store/workspace/slice';
import { endExamThunk, getJobsThunk } from '../../../../../store/workspace/thunks';
import { selectSelectedJob } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { setNotification } from '../../../../../store/general/slice';
import { TrashSquareIcon } from '../../../../../assets/icons';
import CheckBox from '../../../../../components/CheckBox';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useState } from 'react';

interface Reason {
    id: number;
    text: string;
};

const reasonList = [
    {
        id: 1,
        text: 'I’ve already hired.'
    },
    {
        id: 2,
        text: 'I’ve completed my project.'
    },
    {
        id: 3,
        text: 'Other'
    },
];

export default function ConfirmEndExam() {
    const dispatch = useDispatch();
    const [comment, setComment] = useState('');
    const job = useSelector(selectSelectedJob);
    const [loading, setLoading] = useState(false);
    const [selectedReason, setSelectedReason] = useState<Reason | null>(null);

    const endExam = () => {
        if (!job) return;
        setLoading(true);
        const reason = selectedReason?.id === 3 ? comment : (selectedReason?.text || '');

        dispatch(endExamThunk({
            reason,
            id: job.id,
            action: 'end',
        }))
            .unwrap()
            .then(() => {
                dispatch(getJobsThunk({}));
                dispatch(setSelectedJob(null));
                dispatch(setConfirmEndExam(false));
                dispatch(setJobDetailModal(false));
                dispatch(setNotification(['Job ended successfully', 'success']));
            })
            .catch(() => {
                dispatch(setNotification(['Something went wrong,Try again...', 'error']));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            title='End job post'
            icon={<TrashSquareIcon />}
            closeFunc={() => dispatch(setConfirmEndExam(false))}
        >
            <div className={styles.wrapper}>
                <span className={styles.title}>
                    If you confirm end job post, no interviews
                    or tests will be available for applicants.
                </span>
                <div className={styles.reason}>
                    <span>Please select reason for Stop sharing job post:</span>
                    <div className={styles.reason_list}>
                        {reasonList.map(item => <CheckBox
                            key={item.id}
                            text={item.text}
                            checked={selectedReason?.id === item.id}
                            onClick={() => setSelectedReason(item)}
                        />)}
                        {selectedReason?.id === 3 && <Input
                            type='text'
                            value={comment}
                            onChange={setComment}
                            placeholder='please specify'
                        />}
                    </div>
                </div>
                <div className={styles.action}>
                    <Button
                        className={styles.action_btn}
                        type='Outline-Dark'
                        text='Keep it'
                        onClick={() => dispatch(setConfirmEndExam(false))}
                    />
                    <Button
                        className={styles.action_btn}
                        loading={loading}
                        type='Error'
                        text='End it'
                        onClick={endExam}
                        disabled={!selectedReason || (selectedReason.id === 3 && !comment)}
                    />
                </div>
            </div>
        </Modal>
    )
}
